import { InjectionToken } from '@angular/core';
import {
  createInjectionToken,
  createNoopInjectionToken,
} from 'ngxtension/create-injection-token';

/**
 * Scanner-specific configuration
 * Not environment variables - these are app-specific settings
 */
export interface ScannerConfig {
  maxOfflineRecords: number;
  syncIntervalMs: number;
}

export const [injectScannerWsUrl, provideScannerWsUrl] =
  createNoopInjectionToken<string>('SCANNER_WS_URL');

export const ENVIRONMENT = new InjectionToken<
  'development' | 'staging' | 'production'
>('ENVIRONMENT');

export const [injectScannerConfig, provideScannerConfig] = createInjectionToken(
  (): ScannerConfig => ({
    maxOfflineRecords: 1000,
    syncIntervalMs: 30000,
  }),
  {
    isRoot: false,
  },
);
